import React from "react"

const H2Title = (props) => (
    <div className="title">
        <div className="title__line"/>
        <h2>{props.h2}</h2>
    </div>
);

export default H2Title